import React, { createContext, useContext, ReactNode } from 'react';
import {
  useTheme as usePaperTheme,
  ThemeProvider as PaperThemeProvider,
} from 'react-native-paper';
import { lightTheme, darkTheme } from './index';
import { logger } from '../utils/logger';

interface ThemeContextType {
  theme: typeof lightTheme;
  isDark: boolean;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const paperTheme = usePaperTheme();
  const isDark = paperTheme.dark;

  const theme = isDark ? darkTheme : lightTheme;

  const toggleTheme = () => {
    // This would typically be handled by a theme state management system
    // For now, we'll just use the current theme
    logger.log('Toggle theme - implement theme switching logic');
  };

  return (
    <ThemeContext.Provider value={{ theme, isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
